<template>
    <!--图片组-->
    <div class="service">
        <a v-for="(img, index) in ztpdImgData" :key="index" class="servicelist" :href="img.link||'#'" target="_blank">
            <div class="serviceItem">
                <p>{{ img.description }}</p>
                <img :src="img['url-compatible']"  />
            </div>
        </a>
    </div>

</template>

<script setup>
//props
import { ref } from 'vue';
import source from "../components/source.js";
const ztpdImgData = ref(source.ztpdItems)


</script>

<style scoped lang="scss">
.service {
    border-radius: 4px;
    display: flex;
    box-shadow: 0 3px 20px 0 rgba(28, 91, 255, 0.1);
}

.servicelist {
    flex: 1;
}

.serviceItem {
    background: #fff;
    padding: 1.5vw 2vw;
    border-right: 2px solid #f7f7f9;
    transition: all 0.8s;
}

.serviceItem:hover {
    background: #e6effd;
}

.service p {
    font-size: 1.3vw;
    text-align: center;
    margin: 3%;
    color: #000;
    text-decoration: none;
}

.service a:hover {
    text-decoration: none;
}

.service img {
    width: 100%;
    margin-top: 1.3vw;
}

.serviceCenter .service :last-child {
    border: 0;
}
</style>
